import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  Typography,
  Paper,
  Tooltip,
  IconButton,
  // Rating,
  Divider,
  Button,
} from '@mui/material';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import EditIcon from '@mui/icons-material/Edit';
import PersonAddAltRoundedIcon from '@mui/icons-material/PersonAddAltRounded';
import CakeRoundedIcon from '@mui/icons-material/CakeRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
// import StarBorder from '@mui/icons-material/StarBorder';
// import StarIcon from '@mui/icons-material/Star';
import { CenteredFlexBox, ColumnFlexBox } from '../../../Components/FlexBox';
import {
  createNewDate,
  culture,
  options,
  getAge,
} from '../../../Helpers/dates';
import Fab from '../../../Components/Navbar/Fab';
import '../../../Styles/app.scss';
import CaptionValue from '../../../Components/CaptionValue/CaptionValue';

const useStyles = () => ({
  fabBack: {
    position: 'absolute',
    top: '50%',
    left: -20,
    zIndex: 1,
  },
  fabNext: {
    position: 'absolute',
    top: '50%',
    right: -20,
    zIndex: 1,
  },
});

const ClientBoxInfo = function ClientBoxInfo({
  campaignName,
  handleOpenCampaignSelectionDialog,
  contactIndex,
  contactsCount,
  widget,
  title,
  selectedCustomer,
  openDialog,
  isLead,
  onBack,
  onNext,
  onClickNewContact,
  onClickEditContact,
  isLongChannel,
  grow,
}) {
  const classes = useStyles();
  const intl = useIntl();

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    openDialog(selectedCustomer);
  };

  // const rating = parseInt(selectedCustomer?.ratingValue, 10);
  return (
    <ColumnFlexBox
      sx={{
        position: 'relative',
        flexGrow: grow ? 1 : 0,
        height: grow ? '100%' : '60%',
      }}
    >
      {onBack && (
        <Fab
          id="contact-back-fab"
          disabled={contactIndex === 0}
          onClick={onBack}
          sx={classes.fabBack}
          title={intl.messages.PREVIOUS_CONTACT}
        >
          <ArrowBackIosNewRoundedIcon />
        </Fab>
      )}
      {onNext && (
        <Fab
          id="contact-next-fab"
          disabled={contactIndex === contactsCount - 1}
          onClick={onNext}
          sx={classes.fabNext}
          title={intl.messages.NEXT_CONTACT}
        >
          <ArrowForwardIosRoundedIcon />
        </Fab>
      )}
      <Paper
        sx={{
          backgroundColor: 'primary.main',
          color: '#fff',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <ColumnFlexBox padding="16px" gap="8px" flex="0 0 30%">
          <CenteredFlexBox justifyContent="space-between" gap="6px">
            <CaptionValue
              caption={
                campaignName && (
                  <CenteredFlexBox gap="8px">
                    <CampaignRoundedIcon sx={{ color: '#fff' }} />
                    <Typography variant="subtitle1" sx={{
                      color: "#fff"
                    }}>
                      {campaignName}
                    </Typography>
                    <Button
                      disabled={!handleOpenCampaignSelectionDialog}
                      variant="outlined"
                      size="small"
                      sx={{
                        color: '#fff',
                        borderColor: '#fff',
                        marginLeft: '8px',
                      }}
                      onClick={handleOpenCampaignSelectionDialog}
                    >
                      {intl.messages.CHANGE}
                    </Button>
                  </CenteredFlexBox>
                )
              }
              value={
                <CenteredFlexBox gap="8px">
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "24px",
                      color: "#fff",
                      display: '-webkit-box',
                      overflow: 'hidden',
                      WebkitBoxOrient: 'vertical',
                      WebkitLineClamp: 3
                    }}>
                    {title || intl.messages.UNAVAILABLE}
                  </Typography>
                  {openDialog && (
                    <Tooltip
                      title={
                        isLead
                          ? intl.messages.EDIT_LEAD
                          : intl.messages.EDIT_CUSTOMER
                      }
                      placement="bottom"
                    >
                      <IconButton
                        id="edit-customer"
                        aria-label="edit-customer"
                        onClick={(e) => handleClick(e)}
                      >
                        <EditIcon fontSize="inherit" sx={{ color: '#fff' }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </CenteredFlexBox>
              }
            />

            <CenteredFlexBox
              sx={{
                gap: '8px',
                border: '1px solid #fff',
                borderRadius: '50px',
                padding: '4px 8px',
              }}
              gap="4px"
            >
              <Tooltip title={intl.messages.NEW_CONTACT} placement="bottom">
                <IconButton
                  id="new-contact"
                  aria-label="new-contact"
                  onClick={onClickNewContact}
                  sx={{ marginLeft: 'auto' }}
                >
                  <PersonAddAltRoundedIcon
                    fontSize="inherit"
                    sx={{ color: '#fff' }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title={intl.messages.EDIT_CONTACT} placement="bottom">
                <IconButton
                  id="new-contact"
                  aria-label="new-contact"
                  onClick={onClickEditContact}
                  sx={{ marginLeft: 'auto' }}
                >
                  <EditIcon fontSize="inherit" sx={{ color: '#fff' }} />
                </IconButton>
              </Tooltip>
            </CenteredFlexBox>
          </CenteredFlexBox>
          <CenteredFlexBox
            justifyContent={
              selectedCustomer?.birthDate ? 'space-between' : 'flex-end'
            }
          >
            {!isLongChannel && selectedCustomer?.birthDate && (
              <CenteredFlexBox gap="4px">
                <CakeRoundedIcon sx={{ marginBottom: '7px', color: '#fff' }} />
                <Typography variant="body1" noWrap sx={{
                  color: "#fff"
                }}>
                  {selectedCustomer?.birthDate !== null
                    ? `${createNewDate(
                        selectedCustomer?.birthDate
                      ).toLocaleDateString(
                        culture,
                        options
                      )} (${getAge(new Date(selectedCustomer?.birthDate))} ${intl.messages.YEARS})`
                    : ''}
                </Typography>
              </CenteredFlexBox>
            )}

            {/*             <CenteredFlexBox gap="4px">
              <Rating
                readOnly
                precision={1}
                value={rating}
                emptyIcon={
                  <StarBorder fontSize="inherit" sx={{ color: '#fff' }} />
                }
                icon={<StarIcon fontSize="inherit" sx={{ color: '#fff' }} />}
              />
              <Typography variant="body1" color={'#fff'}>
                {rating || 0}
              </Typography>
            </CenteredFlexBox> */}
          </CenteredFlexBox>
          <Divider sx={{ backgroundColor: 'white.main' }} />
        </ColumnFlexBox>
        {widget}
      </Paper>
    </ColumnFlexBox>
  );
};

ClientBoxInfo.propTypes = {
  widget: PropTypes.object.isRequired,
  selectedCustomer: PropTypes.object.isRequired,
  openDialog: PropTypes.func,
  isLead: PropTypes.bool.isRequired,
  title: PropTypes.string,
};

export default ClientBoxInfo;
